import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import qs from 'qs';
import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/mui/Buttons';
import { Commission } from 'types/embedded/commission';

export type LinkTextButtonProps = {
  pathname: string;
} & ButtonProps;

export const CommissionsNewVersionButton: React.FC<LinkTextButtonProps> = ({
  label,
  variant = 'contained',
  color = 'primary',
  pathname,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  const record = useRecordContext<Commission>();

  const search = qs.stringify(
    {
      parent: record?.id,
      provider: record?.provider?.['@id'],
      merchant: record?.merchant?.['@id'],
      transactionTypes: record?.transactionTypes,
      currency: record?.currency?.['@id'],
    },
    { indices: false, encode: true },
  );

  return (
    <Button
      color={color}
      component={Link}
      label={label || translate('app.merchantCommissions.createNewVersion')}
      to={{
        pathname,
        search,
      }}
      variant={variant}
      {...restProps}
    />
  );
};
